import React from 'react';
import PaymentMethod from './PaymentMethod';

interface PaymentMethodData {
  id: string;
  name: string;
  icon: string;
  description: string;
  available: boolean;
}

interface PaymentMethodsProps {
  selectedMethod: string;
  onMethodSelect: (id: string) => void;
  piBalance?: number;
}

const PaymentMethods: React.FC<PaymentMethodsProps> = ({
  selectedMethod,
  onMethodSelect,
  piBalance = 0
}) => {
  const paymentMethods: PaymentMethodData[] = [
    {
      id: 'pi',
      name: 'Pi Network',
      icon: '🥧',
      description: `Balance: π ${piBalance.toFixed(2)} - Official Pi Network integration`,
      available: true
    },
    {
      id: 'paypal',
      name: 'PayPal',
      icon: '💙',
      description: 'Secure payments with PayPal account - Instant processing',
      available: true
    }
  ];

  return (
    <div className="space-y-3">
      <div className="mb-4">
        <h3 className="font-semibold text-gray-800 dark:text-gray-100 mb-2">Choose Payment Method</h3>
        <p className="text-sm text-gray-600 dark:text-gray-300">
          Select your preferred payment method. All transactions are encrypted and secure.
        </p>
      </div>
      
      {paymentMethods.map((method) => (
        <PaymentMethod
          key={method.id}
          id={method.id}
          name={method.name}
          icon={method.icon}
          description={method.description}
          available={method.available}
          selected={selectedMethod === method.id}
          onSelect={onMethodSelect}
        />
      ))}
      
      <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/30 rounded-lg border border-blue-200 dark:border-blue-700">
        <p className="text-xs text-blue-700 dark:text-blue-300">
          <strong>Security Notice:</strong> All payment methods use industry-standard encryption.
          PayPal payments are processed securely with PCI DSS compliance.
          Your payment information is never stored on our servers.
        </p>
      </div>
    </div>
  );
};

export default PaymentMethods;